export const companiesCompanyIdOauthMcpSettings = "/companies/:company_id/oauth_mcp_settings";
